const publicSvg = (filename: string) =>
  `${process.env.PUBLIC_URL ?? ''}/${encodeURI(filename)}`;

const clampTallyValue = (value: number | null | undefined): number | null => {
  if (value == null || Number.isNaN(value)) return null;
  return Math.max(0, Math.min(5, value));
};

const DEFAULT_TALLY_MARKS_SIZE_PX = 56;

type TallyMarksProps = {
  count: number | null | undefined;
  sizePx?: number;
  opacity?: number;
};

const TallyMarks = ({
  count,
  sizePx = DEFAULT_TALLY_MARKS_SIZE_PX,
  opacity = 1,
}: TallyMarksProps) => {
  const c = clampTallyValue(count);
  if (c == null) return null;

  return (
    <img
      src={publicSvg(`tally marks ${c}.svg`)}
      alt={`Tally marks: ${c}`}
      style={{
        width: sizePx,
        height: sizePx,
        opacity,
      }}
    />
  );
};

type GetTallyMarkForCountOptions = {
  count: number | null | undefined;
  sizePx?: number;
  opacity?: number;
};

const getTallyMarkForCount = ({
  count,
  sizePx = DEFAULT_TALLY_MARKS_SIZE_PX,
  opacity = 1,
}: GetTallyMarkForCountOptions) => (
  <TallyMarks count={count} sizePx={sizePx} opacity={opacity} />
);

export { TallyMarks, getTallyMarkForCount, clampTallyValue };
